import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@ebm-papst/ui-theme/_theme.scss'
import {sentryInit} from "./Config/sentry";
import {SnackbarProvider} from "notistack";
import {CustomSuccess} from "./Components/Snackbar/CustomSuccess";
import {CustomInfo} from "./Components/Snackbar/CustomInfo";
import {CustomWarning} from "./Components/Snackbar/CustomWarning";
import {CustomError} from "./Components/Snackbar/CustomError";
import {CustomDefault} from "./Components/Snackbar/CustomDefault";
import {Provider} from "react-redux";
import {store} from "./Redux/store";
import appConfig from "./Config/config";
import { LicenseInfo } from '@mui/x-license'
import {LoadingOverlay} from "./Components/Generic/LoadingOverlay";
import {AuthContextProvider} from "./Keycloak/AuthProvider";
import {keycloak, keycloakInitConfig} from "./Config/keycloak";

LicenseInfo.setLicenseKey(appConfig.muiLicenceKey)
sentryInit()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AuthContextProvider
      authClient={keycloak}
      initOptions={keycloakInitConfig}
      LoadingComponent={<LoadingOverlay keycloak open={true} />}
  >
      <Provider store={store}>
          <SnackbarProvider
              maxSnack={1}
              Components={{
                  customSuccess: CustomSuccess,
                  customInfo: CustomInfo,
                  customWarning: CustomWarning,
                  customError: CustomError,
                  customDefault: CustomDefault
              }}
          >
              <App />
          </SnackbarProvider>
      </Provider>
  </AuthContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// test12
reportWebVitals();
